import {
  CreateWorkSpaceDocument,
  CreateWorkSpaceMutation,
  CreateWorkSpaceMutationVariables,
  WorkSpacesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateWorkSpace = () => {
  const [executeMutation] = useMutation(CreateWorkSpaceDocument, {
    extractorFn: (data: CreateWorkSpaceMutation) =>
      data.spaceControlMutations.createSpacecontrolWorkSpace,
  })

  const createWorkSpace = async (
    variables: CreateWorkSpaceMutationVariables,
    locationId?: number
  ) => {
    return executeMutation({
      variables,
      refetchQueries: [
        {
          query: WorkSpacesDocument,
          variables: {
            locationIds: [locationId],
            workAreaIds: [variables.workAreaId],
          },
        },
      ],
      awaitRefetchQueries: true,
    })
  }

  return {
    createWorkSpace,
  }
}
